import {Component, Fragment} from 'react'

import LandingCompanyUniverse from './LandingCompanyUniverse.jsx'

import businessControllingImg from '../../../media/images/sub-universes/finance/businessControlling.jpg?size=600'
import cfoImg from '../../../media/images/sub-universes/finance/cfo.jpg?size=600'
import consolidationImg from '../../../media/images/sub-universes/finance/consolidation.jpg?size=600'
import headerImg from '../../../media/images/universes/finance.jpg'

const headerBrief = <Fragment>
  <p>Twineeds mobilise un <strong>réseau de consultants spécialisés en finance: mission ponctuelle, projet structurant ou remplacement temporaire</strong>.</p>
  <p>Nos profils sont <strong>disponibles partout en France</strong> pour <strong>renforcer vos équipes financières</strong>. Déposez votre besoin, nous vous proposons un expert métier sur-mesure.</p>
</Fragment>

const title = "Renforcez vos équipes | Consultants experts en Finance"
const description = "Renforcez vos équipes avec des consultants experts en contrôle de gestion, trésorie, consolidation et comptabilité... Rencontrez nos profils qualifiés."

const ourJobsItems = [
  {
    title: 'Direction Administrative et Financière',
    brief: '<p>Des <strong>spécialistes pour structurer et piloter votre direction financière : Directeur Administratif et Financier (DAF), Responsable Administratif et Financier (RAF), Responsable Comptable, Directeur Financier</strong>, etc.</p>' +
      '<p>Des <strong>experts en contrôle de gestion</strong> pour piloter votre performance : <strong>profils spécialisés en social, projet, industriel ou IT</strong>.</p>',
    img: cfoImg.src,
    imgAlt: 'Poignée de main entre consultant expert et professionnel'
  },
  {
    title: 'Contrôle de gestion',
    brief: '<p>Des <strong>experts en contrôle de gestion</strong> : <strong>contrôleur de gestion social, contrôleur de gestion projet, contrôleur de gestion industriel, contrôleur de gestion IT</strong>, etc.</p>',
    img: businessControllingImg.src,
    imgAlt: 'Conseil d\'une consultante finance pointant des documents'
  },
  {
    title: 'Consolidation',
    brief: '<p>Des experts pour <strong>fiabiliser vos reportings et bilans financiers : responsable consolidation, consolideur, directeur consolidation, analyste consolidation</strong>, etc.</p>',
    img: consolidationImg.src,
    imgAlt: 'Mission d\'une consultante finance sur un bureau avec des documents'
  }
]

const specificDifference = <Fragment><strong>Un réseau de consultants spécialisés</strong> pour structurer vos projets transverses et accompagner le changement.</Fragment>

export default class LandingCompanyFinance extends Component {
  render() {
    return <LandingCompanyUniverse
      headerBrief={headerBrief}
      headerImg={headerImg.src}
      headerImgAlt="Consultant finance conseille une entreprise autour d\'un bureau"
      helmet={{title, description}}
      ourJobsItems={ourJobsItems}
      specificDifference={specificDifference}
      title="Vous cherchez un consultant expert en finance ? Confiez-nous votre besoin"
      universeCode="finance"
    />
  }
}
